export default {
  Title: 'Clients',
  Action: 'Create new client',
  ClientStatus: 'Client status: ',
  Relationships: 'Relationships: ',
  Caregivers: 'Caregivers: ',
  Filter: {
    Status: 'Status',
  },
};
